import * as React from 'react';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { SystemModule } from '~/Api/Authentication';
import * as InfoCardApi from '~/Api/InfoCard';
import { useStore } from '~/Application/Store';
import { BetaLabel } from '~/BetaLabel';
import { TimePeriodGenerator } from '~/Date';
import { YearMonthPicker } from '~/Date/YearMonthPicker';
import { MessageType, useFlashMessage } from '~/FlashMessage';
var period = new TimePeriodGenerator();
var monthRange = [
    {
        content: 'Tento měsíc',
        value: period.currentMonth,
    },
    {
        content: 'Minulý měsíc',
        value: period.previousMonth,
    },
    {
        content: '12 posledních měsíců',
        value: period.previous12Months,
    },
];
var quarterRange = [
    {
        content: 'Aktuální čtvrtletí',
        value: period.currentQuarter,
    },
    {
        content: 'Minulé čtvrtletí',
        value: period.previousQuarter,
    },
    {
        content: '4 poslední čtvrtletí',
        value: period.previous4Quarters,
    },
];
var yearRange = [
    {
        content: 'Aktuální rok',
        value: period.currentYear,
    },
    {
        content: 'Minulý rok',
        value: period.previousYear,
    },
];
var Period;
(function (Period) {
    Period["month"] = "month";
    Period["year"] = "year";
    Period["quarter"] = "quarter";
    Period["deafult"] = "deafult";
    Period["custom"] = "custom";
})(Period || (Period = {}));
export var DateFilter = function (_a) {
    var _b, _c;
    var filter = _a.filter, onUpdate = _a.onUpdate;
    var _d = useFlashMessage(), setFlashMessage = _d[1];
    var _e = React.useState(((_b = filter.conditions.find(function (condition) { return condition.type === InfoCardApi.ConditionType.dateFrom; })) === null || _b === void 0 ? void 0 : _b.value) !== undefined ||
        ((_c = filter.conditions.find(function (condition) { return condition.type === InfoCardApi.ConditionType.dateTo; })) === null || _c === void 0 ? void 0 : _c.value) !== undefined
        ? Period.custom
        : Period.deafult), period = _e[0], setPeriod = _e[1];
    var systemModules = useStore().systemModules;
    var allowFullDateFilter = systemModules.find(function (module) { return module === SystemModule.infoCardsFullyFeaturedDateFilter; }) !== undefined;
    var dateRange = React.useMemo(function () {
        var _a, _b, _c, _d;
        return [
            (_b = (_a = filter.conditions.find(function (condition) { return condition.type === InfoCardApi.ConditionType.dateFrom; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
            (_d = (_c = filter.conditions.find(function (condition) { return condition.type === InfoCardApi.ConditionType.dateTo; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '',
        ];
    }, [filter]);
    var updateDateRange = function (dateRange, period) {
        var _a, _b;
        var validDate = new Date(dateRange[1]).getTime() >= new Date(dateRange[0]).getTime();
        if (!validDate && dateRange[0] !== '' && dateRange[1] !== '') {
            setFlashMessage({ text: 'Neplatné časové rozmezí', type: MessageType.error });
            return;
        }
        setPeriod(period);
        onUpdate(filter
            .toggle({ type: InfoCardApi.ConditionType.dateFrom, value: (_a = dateRange[0]) !== null && _a !== void 0 ? _a : '' })
            .toggle({ type: InfoCardApi.ConditionType.dateTo, value: (_b = dateRange[1]) !== null && _b !== void 0 ? _b : '' }));
    };
    return (<Segment data-testid='date-filters'>
			<Header.Content as='h5' floated='left'>
				{allowFullDateFilter ? <BetaLabel /> : null}
				Nastavení sledovaného období
			</Header.Content>
			<Form>
				<Button.Group compact size='tiny'>
					<Button color={period === Period.deafult ? 'blue' : undefined} content='Bez omezení' size='tiny' onClick={function () {
            updateDateRange(['', ''], Period.deafult);
        }}/>
					<Button color={period === Period.custom ? 'blue' : undefined} content='Ruční nastavení' size='tiny' onClick={function () {
            setPeriod(Period.custom);
        }}/>
				</Button.Group>
				<Button.Group compact size='tiny'>
					{monthRange.map(function (date, i) {
            var isActive = date.value[0] === dateRange[0] && date.value[1] === dateRange[1] && period === Period.month;
            if (!allowFullDateFilter && i === 2) {
                return null;
            }
            return (<Button color={isActive ? 'blue' : undefined} content={date.content} key={i} size='tiny' onClick={function () {
                    updateDateRange(isActive ? ['', ''] : date.value, Period.month);
                }}/>);
        })}
				</Button.Group>
				{allowFullDateFilter ? (<Button.Group compact size='tiny'>
						{quarterRange.map(function (date, i) {
                var isActive = date.value[0] === dateRange[0] && date.value[1] === dateRange[1] && period === Period.quarter;
                return (<Button color={isActive ? 'blue' : undefined} content={date.content} key={i} size='tiny' onClick={function () {
                        updateDateRange(isActive ? ['', ''] : date.value, Period.quarter);
                    }}/>);
            })}
					</Button.Group>) : null}
				<Button.Group compact size='tiny'>
					{yearRange.map(function (date, i) {
            var isActive = date.value[0] === dateRange[0] && date.value[1] === dateRange[1] && period === Period.year;
            return (<Button color={isActive ? 'blue' : undefined} content={date.content} key={i} size='tiny' onClick={function () {
                    updateDateRange(isActive ? ['', ''] : date.value, Period.year);
                }}/>);
        })}
				</Button.Group>
			</Form>

			{period === Period.custom ? (<Segment>
					<Form className='date-picker-form'>
						<YearMonthPicker label='Vyberte začátek sledovaného období' value={dateRange[0]} onSelect={function (date) {
                updateDateRange([date, dateRange[1]], Period.custom);
            }}/>

						<YearMonthPicker label='Vyberte konec sledovaného období' value={dateRange[1]} onSelect={function (date) {
                updateDateRange([dateRange[0], date], Period.custom);
            }}/>
					</Form>
				</Segment>) : null}
		</Segment>);
};
